import script from "./SimulatePriceController.vue?vue&type=script&setup=true&lang=js"
export * from "./SimulatePriceController.vue?vue&type=script&setup=true&lang=js"

import "./SimulatePriceController.vue?vue&type=style&index=0&id=76831e67&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76831e67"]])

export default __exports__